// extracted by mini-css-extract-plugin
module.exports = {"formCard":"styles_formCard__3WlAB","data":"styles_data__1umb7"};